import React, { useEffect } from 'react';
import { PromptInputProps } from './interfaces';

const PromptInput: React.FC<PromptInputProps> = ({
  prompt,
  onSubmit,
  updatePrompt,
}) => {
  useEffect(() => {
    const checkKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        onSubmit();
      }
    };

    window.addEventListener('keydown', checkKeyPress);

    return () => {
      window.removeEventListener('keydown', checkKeyPress);
    };
  }, [onSubmit]);

  return (
    <textarea
      value={prompt}
      onChange={e => updatePrompt(e.target.value)}
      style={{ width: '100%' }}
    />
  );
};

export default PromptInput;
